export const TwitterIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 400 409"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8269_5210)">
      <path
        d="M238.054 173.095L386.963 0H351.677L222.379 150.296L119.109 0H0L156.164 227.274L0 408.79H35.2887L171.83 250.073L280.891 408.79H400L238.046 173.095H238.054ZM189.722 229.276L173.899 206.645L48.0037 26.5648H102.205L203.804 171.895L219.627 194.526L351.693 383.433H297.492L189.722 229.285V229.276Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_8269_5210">
        <rect width="400" height="409" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
